import { render, staticRenderFns } from "./L1.vue?vue&type=template&id=28cc01bd&scoped=true&"
import script from "./L1.vue?vue&type=script&lang=js&"
export * from "./L1.vue?vue&type=script&lang=js&"
import style0 from "./L1.vue?vue&type=style&index=0&id=28cc01bd&lang=less&scoped=true&"
import style1 from "./L1.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc01bd",
  null
  
)

export default component.exports